import { GUILD_AGE_RECOMMENDATIONS } from '@/constants/guildAgeRecommendations'
import { logger } from '@/utils/logging'

export interface GuildRating {
  ageText: string
  description: string
}

/**
 * Fetches guild age rating information for a given project slug.
 * This is currently a pseudo service that checks against local constants,
 * but is designed to be easily replaceable with an API call in the future.
 *
 * @param projectSlug - The slug of the project to get rating for
 * @returns Promise resolving to guild rating data or null if not found
 */
export const getGuildRatingBySlug = async (projectSlug: string): Promise<GuildRating | null> => {
  try {
    const rating = GUILD_AGE_RECOMMENDATIONS[projectSlug as keyof typeof GUILD_AGE_RECOMMENDATIONS]

    if (!rating) {
      logger().debug(`No guild rating found for project slug: ${projectSlug}`)
      return null
    }

    return {
      ageText: rating.ageText,
      description: rating.description,
    }
  } catch (error) {
    logger().error(`Error fetching guild rating for slug ${projectSlug}:`, error)
    return null
  }
}
